export default __webpack_public_path__ + "static/media/Safety ladder - Copy.11a7c85d.jpg";